import React, { useState } from "react";
import tracking from "@irati-tracking/homepage";
import ContentHeader from "./Header";
import { Modal } from "../../Modal";
import { SelectedTab } from "./types";
import ContentForm from "./Form";
var CompanyNewsContentModal = function (_a) {
    var companyNewsTile = _a.companyNewsTile, onClose = _a.onClose;
    var _b = useState(SelectedTab.IMAGE), currentTab = _b[0], setTab = _b[1];
    var _c = useState(false), isPreview = _c[0], setPreview = _c[1];
    return (React.createElement(Modal, { header: React.createElement(ContentHeader, { currentTab: currentTab, isPreview: isPreview, setTab: function (tab) {
                tracking.homePageAddNewTileChangeTab(tab);
                setTab(tab);
            } }), onClose: onClose },
        React.createElement(ContentForm, { companyNewsTile: companyNewsTile, currentTab: currentTab, isPreview: isPreview, onClose: onClose, setPreview: setPreview })));
};
export default CompanyNewsContentModal;
